import { Grid } from "drift-ui";
import styled from "styled-components";

export const StyledHeader = styled.div`
  font-size: 36px;
  margin-bottom: 0;
  padding-top: 24px;
`;

export const PageContainer = styled.div`
  background-color: white;
  height: 91vh;
  width: 100vw;
`;

export const ContentContainer = styled.div`
  padding: 0px 25px 0px 25px;
`;

export const StyledGrid = styled(Grid)`
  overflow-x: auto;
`;

export const Row = styled.div`
  width: 100%;
`;

export const InputRow = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
  padding: 24px 0;
`;

export const PageNavFlex = styled.div`
  display: flex;
  align-items: center;
  padding: 7px;
  float: right;
`;

export const SpinnerContainer = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  height: 50%;
  justify-content: center;
  position: absolute;
  width: 95%;
  z-index: 1;
`;

export const StyledTable = styled.table`
  margin-top: 75px;
  min-width: 1200px;
  overflow: scroll;
  display: block;
  height: 50vh;
  border-collapse: collapse;
  width: 100%;
`;

export const TableHead = styled.thead`
  display: table;
  width: 100%;
  table-layout: fixed;
  font-weight: bold;
`;

export const TableBody = styled.tbody`
  display: inline-table;
  table-layout: fixed;
  width: 100%;
`;

export const StyledRow = styled.tr`
  padding: 5px;
  border-bottom: 1px solid #0000001f;
`;

export const StyledCell = styled.td`
  padding: 13px;
`;

export const CallTypeCell = styled(StyledCell)`
  width: 11%;
`;

export const ClientCodeCell = styled(StyledCell)`
  width: 12%;
`;

export const UsernameCell = styled(StyledCell)`
  width: 13%;
`;

export const DateCell = styled(StyledCell)`
  width: 14%;
`;

export const FileNameCell = styled(StyledCell)`
  width: 24%;
`;

export const RequestCell = styled(StyledCell)`
  width: 13%;
`;

export const ResponseCell = styled(StyledCell)`
  width: 13%;
`;

export const TableFooter = styled.div`
  background: #f9f9f9;
  width: 100%;
  height: 64px;
`;

export const DownloadText = styled.span`
  color: #0091ea;
  padding-left: 4px;
  cursor: pointer;
`;
